import React from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, Sparkles, ArrowRight } from "lucide-react";
import { PLACEHOLDER_META } from "../lib/constants";

export default function PlaceholderPage({ moduleKey }) {
  const meta = PLACEHOLDER_META[moduleKey] || {
    title: "Módulo",
    subtitle: "Contenido próximamente.",
    color: "#1E3A8A",
    stats: [],
  };

  return (
    <div className="px-5 md:px-8 py-8" data-testid={`placeholder-page-${moduleKey}`}>
      <Link to="/" className="inline-flex items-center gap-1 text-sm font-semibold text-slate-500 hover:text-slate-800">
        <ChevronLeft size={16} /> Volver al Ecosistema
      </Link>

      <section
        className="mt-4 rounded-3xl border border-slate-100 shadow-soft bg-white p-8 md:p-10"
        style={{ background: `linear-gradient(135deg, #FFFFFF 65%, ${meta.color}15 100%)` }}
      >
        <p className="text-[11px] font-bold uppercase tracking-[0.2em]" style={{ color: meta.color }}>
          Módulo ConstruLink
        </p>
        <h1 className="mt-2 text-3xl md:text-4xl font-extrabold text-slate-900 tracking-tight">
          {meta.title}
        </h1>
        <p className="mt-3 text-base text-slate-600 max-w-2xl">{meta.subtitle}</p>

        <div className="mt-6 flex gap-3 flex-wrap">
          <button
            className="inline-flex items-center gap-2 text-white font-semibold px-5 py-2.5 rounded-xl shadow-sm hover:brightness-110 transition-all"
            style={{ backgroundColor: meta.color }}
            data-testid={`placeholder-cta-${moduleKey}`}
          >
            Empezar ahora <ArrowRight size={16} />
          </button>
          <button className="inline-flex items-center gap-2 border border-slate-200 hover:border-slate-300 hover:bg-white text-slate-700 font-semibold px-5 py-2.5 rounded-xl transition-colors">
            <Sparkles size={16} /> Ver tutorial
          </button>
        </div>

        {meta.stats?.length > 0 && (
          <div className="mt-8 grid grid-cols-3 gap-3 max-w-md">
            {meta.stats.map(([label, value]) => (
              <div key={label} className="bg-white/70 backdrop-blur-sm rounded-xl border border-slate-100 p-3 text-center">
                <p className="text-lg font-extrabold" style={{ color: meta.color }}>{value}</p>
                <p className="text-[10px] font-semibold uppercase tracking-wide text-slate-500">{label}</p>
              </div>
            ))}
          </div>
        )}
      </section>

      <section className="mt-10 grid grid-cols-1 lg:grid-cols-3 gap-6">
        {["Panorama general", "Actividad reciente", "Próximos pasos"].map((t, i) => (
          <div key={t} className="bg-white rounded-2xl border border-slate-100 shadow-soft p-6">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-400">Sección</p>
            <h3 className="mt-2 text-base font-bold text-slate-900">{t}</h3>
            <p className="mt-2 text-sm text-slate-600">
              Este panel está preparado para recibir información en tiempo real desde el backend ConstruLink una vez conectado el módulo definitivo.
            </p>
            <div className="mt-4 h-24 rounded-xl bg-gradient-to-br from-slate-50 to-white border border-dashed border-slate-200 flex items-center justify-center text-xs text-slate-400 font-semibold">
              Contenido próximamente
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
